// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__Anqx8","aboutImg":"About_aboutImg__YT2l5","aboutText":"About_aboutText__kdh9U","aboutBtn":"About_aboutBtn__HF9C+"};